module.exports = __webpack_public_path__ + "assets/images_base/st-no-audio.svg?v=22944fc9";